export default {"src":"/_next/static/media/for-publishers-2.ab6594fd.svg","height":1358,"width":1440};